import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

interface SortButtonProps {
  label: string;
  field: string;
  currentField: string;
  currentDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
  className?: string;
}

export function SortButton({
  label,
  field,
  currentField,
  currentDirection,
  onSort,
  className = '',
}: SortButtonProps) {
  const isActive = currentField === field;

  return (
    <button
      type="button"
      onClick={() => onSort(field)}
      className={`inline-flex items-center space-x-1 font-semibold text-xs text-slate-600 hover:text-brand-navy transition-colors select-none ${className}`}
    >
      <span>{label}</span>
      {isActive ? (
        currentDirection === 'asc' ? (
          <ArrowUp className="h-3.5 w-3.5 text-brand-teal" />
        ) : (
          <ArrowDown className="h-3.5 w-3.5 text-brand-teal" />
        )
      ) : (
        <ArrowUpDown className="h-3 w-3 text-slate-300 hover:text-slate-500" />
      )}
    </button>
  );
}
